var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "form",
      {
        attrs: { "data-vv-scope": "custom-document", autocomplete: "off" },
        on: {
          submit: function($event) {
            $event.preventDefault()
          }
        }
      },
      [
        _c("h2", { staticClass: "mb-10" }, [
          _vm._v("Informe de uso y custodia de vehículos fiscales")
        ]),
        _c("h4", [_vm._v("Antecedentes generales")]),
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-6" },
            [
              _c("list-groups", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'"
                  }
                ],
                ref: "division",
                attrs: {
                  danger: _vm.errors.has("custom-document.division"),
                  "danger-text": _vm.errors.first("custom-document.division"),
                  "data-vv-as": "división",
                  autocomplete: "",
                  label: "División *",
                  name: "division",
                  "data-cy": "division",
                  typeList: _vm.stepTypes.GROUP,
                  showOnlyDivissions: ""
                },
                model: {
                  value: _vm.formData.division,
                  callback: function($$v) {
                    _vm.$set(_vm.formData, "division", $$v)
                  },
                  expression: "formData.division"
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-6" },
            [
              _c("list-groups", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'"
                  }
                ],
                ref: "department",
                attrs: {
                  danger: _vm.errors.has("custom-document.department"),
                  "danger-text": _vm.errors.first("custom-document.department"),
                  "data-vv-as": "departamento/unidades",
                  autocomplete: "",
                  label: "Departamento/Unidades *",
                  name: "department",
                  "data-cy": "department",
                  typeList: _vm.stepTypes.GROUP,
                  showOnlyUnits: ""
                },
                on: { input: _vm.setLeader },
                model: {
                  value: _vm.formData.department,
                  callback: function($$v) {
                    _vm.$set(_vm.formData, "department", $$v)
                  },
                  expression: "formData.department"
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-6" },
            [
              _c(
                "b-form-group",
                { attrs: { label: "Responsable departamento/unidad *" } },
                [
                  _c("b-form-input", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      }
                    ],
                    attrs: {
                      state: _vm.errors.has("custom-document.leader")
                        ? false
                        : null,
                      "data-vv-as": "responsable dep/uni",
                      "data-cy": "leader",
                      name: "leader",
                      type: "text",
                      placeholder: _vm.leaderPlaceholder,
                      disabled: ""
                    },
                    model: {
                      value: _vm.formData.leader,
                      callback: function($$v) {
                        _vm.$set(_vm.formData, "leader", $$v)
                      },
                      expression: "formData.leader"
                    }
                  }),
                  _vm.errors.has("custom-document.leader")
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "con-text-validation span-text-validation-danger v-enter-to",
                          staticStyle: { height: "19px" }
                        },
                        [
                          _c("span", { staticClass: "span-text-validation" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.errors.first("custom-document.leader")
                                ) +
                                " "
                            )
                          ])
                        ]
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-6" },
            [
              _c(
                "b-form-group",
                { attrs: { label: "Proceso revisado *" } },
                [
                  _c("b-form-input", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      }
                    ],
                    attrs: {
                      state: _vm.errors.has("custom-document.process")
                        ? false
                        : null,
                      "data-vv-as": "proceso revisado",
                      "data-cy": "process",
                      name: "process",
                      type: "text"
                    },
                    model: {
                      value: _vm.formData.process,
                      callback: function($$v) {
                        _vm.$set(_vm.formData, "process", $$v)
                      },
                      expression: "formData.process"
                    }
                  }),
                  _vm.errors.has("custom-document.process")
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "con-text-validation span-text-validation-danger v-enter-to",
                          staticStyle: { height: "19px" }
                        },
                        [
                          _c("span", { staticClass: "span-text-validation" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.errors.first("custom-document.process")
                                ) +
                                " "
                            )
                          ])
                        ]
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-6" },
            [
              _c(
                "b-form-group",
                [
                  _c("list-user", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      }
                    ],
                    ref: "vehicle",
                    attrs: {
                      danger: _vm.errors.has("custom-document.vehicle"),
                      "danger-text": _vm.errors.first(
                        "custom-document.vehicle"
                      ),
                      "data-vv-as": "coordinación de vehículos fiscales",
                      autocomplete: "",
                      "data-cy": "vehicle",
                      name: "vehicle",
                      label: "Coordinación de vehículos fiscales *"
                    },
                    on: { "full-user": _vm.setPosition },
                    model: {
                      value: _vm.formData.vehicle,
                      callback: function($$v) {
                        _vm.$set(_vm.formData, "vehicle", $$v)
                      },
                      expression: "formData.vehicle"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-6" },
            [
              _c(
                "b-form-group",
                { attrs: { label: "Cargo *" } },
                [
                  _c("b-form-input", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      }
                    ],
                    attrs: {
                      state: _vm.errors.has("custom-document.position")
                        ? false
                        : null,
                      "data-vv-as": "cargo",
                      "data-cy": "position",
                      name: "position",
                      type: "text"
                    },
                    model: {
                      value: _vm.formData.position,
                      callback: function($$v) {
                        _vm.$set(_vm.formData, "position", $$v)
                      },
                      expression: "formData.position"
                    }
                  }),
                  _vm.errors.has("custom-document.position")
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "con-text-validation span-text-validation-danger v-enter-to",
                          staticStyle: { height: "19px" }
                        },
                        [
                          _c("span", { staticClass: "span-text-validation" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.errors.first("custom-document.position")
                                ) +
                                " "
                            )
                          ])
                        ]
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-6" },
            [
              _c(
                "b-form-group",
                [
                  _c("list-user", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      }
                    ],
                    ref: "madeBy",
                    attrs: {
                      danger: _vm.errors.has("custom-document.madeBy"),
                      "danger-text": _vm.errors.first("custom-document.madeBy"),
                      "data-vv-as": "informe realizado por",
                      autocomplete: "",
                      "data-cy": "made-by",
                      name: "madeBy",
                      label: "Informe realizado por *"
                    },
                    on: { "full-user": _vm.setPositionMadeBy },
                    model: {
                      value: _vm.formData.madeBy,
                      callback: function($$v) {
                        _vm.$set(_vm.formData, "madeBy", $$v)
                      },
                      expression: "formData.madeBy"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-6" },
            [
              _c(
                "b-form-group",
                { attrs: { label: "Cargo *" } },
                [
                  _c("b-form-input", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      }
                    ],
                    attrs: {
                      state: _vm.errors.has("custom-document.madeByPosition")
                        ? false
                        : null,
                      "data-vv-as": "cargo",
                      "data-cy": "made-by-position",
                      name: "madeByPosition",
                      type: "text"
                    },
                    model: {
                      value: _vm.formData.madeByPosition,
                      callback: function($$v) {
                        _vm.$set(_vm.formData, "madeByPosition", $$v)
                      },
                      expression: "formData.madeByPosition"
                    }
                  }),
                  _vm.errors.has("custom-document.madeByPosition")
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "con-text-validation span-text-validation-danger v-enter-to",
                          staticStyle: { height: "19px" }
                        },
                        [
                          _c("span", { staticClass: "span-text-validation" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.errors.first(
                                    "custom-document.madeByPosition"
                                  )
                                ) +
                                " "
                            )
                          ])
                        ]
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ]),
        _c("div", { staticClass: "col-md-12" }, [_c("vs-divider")], 1),
        _c("h4", [_vm._v("Identificación de la revisión")]),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-12" }, [
            _vm._m(0),
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-6 text-center" },
                [
                  _c(
                    "b-form-group",
                    { attrs: { label: "Mes *" } },
                    [
                      _c("v-select", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'"
                          }
                        ],
                        class: {
                          "v-select-danger": _vm.errors.has(
                            "custom-document.scopeMonth"
                          )
                        },
                        attrs: {
                          state: _vm.errors.has("custom-document.scopeMonth")
                            ? false
                            : null,
                          "data-vv-as": "mes",
                          name: "scopeMonth",
                          "data-cy": "scope-month",
                          options: _vm.months
                        },
                        model: {
                          value: _vm.formData.scopeMonth,
                          callback: function($$v) {
                            _vm.$set(_vm.formData, "scopeMonth", $$v)
                          },
                          expression: "formData.scopeMonth"
                        }
                      }),
                      _vm.errors.has("custom-document.scopeMonth")
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "con-text-validation span-text-validation-danger v-enter-to",
                              staticStyle: { height: "19px" }
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "span-text-validation" },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.errors.first(
                                          "custom-document.scopeMonth"
                                        )
                                      ) +
                                      " "
                                  )
                                ]
                              )
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col-6 text-center" },
                [
                  _c(
                    "b-form-group",
                    { attrs: { label: "Año *" } },
                    [
                      _c("v-select", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'"
                          }
                        ],
                        class: {
                          "v-select-danger": _vm.errors.has(
                            "custom-document.scopeYear"
                          )
                        },
                        attrs: {
                          taggable: "",
                          state: _vm.errors.has("custom-document.scopeYear")
                            ? false
                            : null,
                          "data-vv-as": "año",
                          name: "scopeYear",
                          "data-cy": "scope-year",
                          options: _vm.years
                        },
                        model: {
                          value: _vm.formData.scopeYear,
                          callback: function($$v) {
                            _vm.$set(_vm.formData, "scopeYear", $$v)
                          },
                          expression: "formData.scopeYear"
                        }
                      }),
                      _vm.errors.has("custom-document.scopeYear")
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "con-text-validation span-text-validation-danger v-enter-to",
                              staticStyle: { height: "19px" }
                            },
                            [
                              _c(
                                "span",
                                { staticClass: "span-text-validation" },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.errors.first(
                                          "custom-document.scopeYear"
                                        )
                                      ) +
                                      " "
                                  )
                                ]
                              )
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ])
          ])
        ]),
        _c("div", { staticClass: "col-md-12" }, [_c("vs-divider")], 1),
        _c("h4", [_vm._v("Informe detallado de resultados")]),
        _c(
          "div",
          { staticClass: "col-md-12" },
          [
            _c(
              "b-form-group",
              { attrs: { label: "Objetivos específicos *" } },
              [
                _c("editor-text", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required",
                      expression: "'required'"
                    }
                  ],
                  ref: "specificObjectives",
                  attrs: {
                    danger: _vm.errors.has(
                      "custom-document.specificObjectives"
                    ),
                    "danger-text": _vm.errors.first(
                      "custom-document.specificObjectives"
                    ),
                    "data-cy": "specific-objectives",
                    "data-vv-as": "objetivos específicos",
                    "max-length": 14000,
                    name: "specificObjectives",
                    "with-counter": ""
                  },
                  model: {
                    value: _vm.formData.specificObjectives,
                    callback: function($$v) {
                      _vm.$set(_vm.formData, "specificObjectives", $$v)
                    },
                    expression: "formData.specificObjectives"
                  }
                })
              ],
              1
            )
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-md-12" },
          [
            _c(
              "b-form-group",
              { attrs: { label: "Resultado detallado de la revisión *" } },
              [
                _c("editor-text", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required",
                      expression: "'required'"
                    }
                  ],
                  ref: "reviewResult",
                  class: {
                    "v-select-danger": _vm.errors.has(
                      "custom-document.reviewResult"
                    )
                  },
                  attrs: {
                    danger: _vm.errors.has("custom-document.reviewResult"),
                    "danger-text": _vm.errors.first(
                      "custom-document.reviewResult"
                    ),
                    "data-cy": "review-result",
                    "data-vv-as": "resultado detallado revisión",
                    "max-length": 14000,
                    name: "reviewResult",
                    "with-counter": ""
                  },
                  model: {
                    value: _vm.formData.reviewResult,
                    callback: function($$v) {
                      _vm.$set(_vm.formData, "reviewResult", $$v)
                    },
                    expression: "formData.reviewResult"
                  }
                })
              ],
              1
            )
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-md-12" },
          [
            _c(
              "b-form-group",
              { attrs: { label: "Nota *" } },
              [
                _c("editor-text", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required",
                      expression: "'required'"
                    }
                  ],
                  ref: "note",
                  class: {
                    "v-select-danger": _vm.errors.has("custom-document.note")
                  },
                  attrs: {
                    danger: _vm.errors.has("custom-document.note"),
                    "danger-text": _vm.errors.first("custom-document.note"),
                    "data-cy": "note",
                    "data-vv-as": "nota",
                    "max-length": 14000,
                    name: "note",
                    "with-counter": ""
                  },
                  model: {
                    value: _vm.formData.note,
                    callback: function($$v) {
                      _vm.$set(_vm.formData, "note", $$v)
                    },
                    expression: "formData.note"
                  }
                })
              ],
              1
            )
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "col-md-12" },
          [
            _c(
              "b-form-group",
              { attrs: { label: "Hallazgos *" } },
              [
                _c("editor-text", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required",
                      expression: "'required'"
                    }
                  ],
                  ref: "findings",
                  class: {
                    "v-select-danger": _vm.errors.has(
                      "custom-document.findings"
                    )
                  },
                  attrs: {
                    danger: _vm.errors.has("custom-document.findings"),
                    "danger-text": _vm.errors.first("custom-document.findings"),
                    "data-cy": "findings",
                    "data-vv-as": "hallazgos",
                    "max-length": 14000,
                    name: "findings",
                    "with-counter": ""
                  },
                  model: {
                    value: _vm.formData.findings,
                    callback: function($$v) {
                      _vm.$set(_vm.formData, "findings", $$v)
                    },
                    expression: "formData.findings"
                  }
                })
              ],
              1
            )
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "row align-items-center mt-5" },
          [
            _vm._m(1),
            _c(
              "div",
              { staticClass: "col-md-3 align-items-end" },
              [
                _c("upload-file", {
                  attrs: {
                    color: _vm.attachmentError ? "danger" : "primary",
                    permission: "*",
                    accept: "application/pdf, .doc, .docx, .xlsv, .ppt",
                    text: "Seleccionar documentos",
                    "data-cy": "uploadFile",
                    "upload-to": "ed",
                    "button-class": "btn-block",
                    "container-class": "w-100"
                  },
                  on: {
                    input: function($event) {
                      return _vm.addFile()
                    }
                  },
                  model: {
                    value: _vm.file,
                    callback: function($$v) {
                      _vm.file = $$v
                    },
                    expression: "file"
                  }
                })
              ],
              1
            ),
            _vm._l(_vm.formData.attachments, function(file) {
              return _c("div", { key: file.id, staticClass: "col-2" }, [
                _c(
                  "div",
                  { staticClass: "d-flex flex-column align-items-center" },
                  [
                    _c("vs-icon", {
                      attrs: {
                        icon: "description",
                        size: "25px",
                        color: "primary"
                      }
                    }),
                    _c(
                      "b",
                      { staticClass: "text-truncate w-100 text-center" },
                      [_vm._v(_vm._s(file.name))]
                    ),
                    _c("vs-button", {
                      attrs: {
                        color: "danger",
                        type: "flat",
                        icon: "clear",
                        "data-cy": "removeOthersFile"
                      },
                      on: {
                        click: function($event) {
                          return _vm.removeOthersFile(file.id)
                        }
                      }
                    })
                  ],
                  1
                )
              ])
            })
          ],
          2
        ),
        !!_vm.error.message
          ? _c(
              "div",
              {
                staticClass:
                  "con-text-validation span-text-validation-danger\n            vs-input--text-validation-span v-enter-to text-right"
              },
              [
                _c("span", { staticClass: "span-text-validation" }, [
                  _vm._v(" " + _vm._s(_vm.error.message) + " ")
                ])
              ]
            )
          : _vm._e()
      ]
    ),
    _c(
      "div",
      { staticClass: "row justify-end" },
      [
        _c(
          "vs-button",
          {
            staticClass: "mt-5 mr-5",
            attrs: {
              "data-cy": "cancel",
              color: "primary",
              disabled: _vm.saving
            },
            on: {
              click: function($event) {
                return _vm.back()
              }
            }
          },
          [_vm._v(" Cancelar ")]
        ),
        _c(
          "vs-button",
          {
            staticClass: "mt-5 mr-5",
            attrs: {
              "data-cy": "save",
              color: "success",
              disabled: _vm.saving
            },
            on: {
              click: function($event) {
                return _vm.save()
              }
            }
          },
          [
            _vm._v(" Crear "),
            _c("span", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.saving,
                  expression: "saving"
                }
              ],
              staticClass: "spinner-border spinner-border-sm text-primary"
            })
          ]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12 text-center" }, [
      _c("strong", [_vm._v("Alcance")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-12" }, [
      _c("label", [_vm._v("Adjuntos *")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }